<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiPowerStandby } from "@mdi/js";
export default {
  name: "MdiPowerStandby",
  data() {
    return {
      svgPath: mdiPowerStandby,
    };
  },
};
</script>
